import React from 'react';
import PropTypes from 'prop-types';

function Postcode({ postcode }) {
    return (
        <span className="statusbar-mobile-current-status__postcode-cta">{ postcode }</span>
    );
}

Postcode.propTypes = {
    postcode: PropTypes.string.isRequired
};

export { Postcode };
